import { nullishToOptional } from "../helpers";
import { z } from "zod";
//
// Enums
//
export const DesignSystemAccessMode = z.enum(["Open", "InviteOnly"]);
// DNS-label-safe
const DOC_USER_SLUG_REGEX = /^[a-z0-9](?:[a-z0-9-]{0,30}[a-z0-9])?$/;
const DocUserSlugSchema = z
    .string()
    .min(1)
    .max(32)
    .regex(DOC_USER_SLUG_REGEX, "Documentation slug can only contain lowercase letters, digits, and hyphens, and cannot start or end with a hyphen.");
//
// Model
//
export const DesignSystemSwitcher = z.object({
    isEnabled: z.boolean(),
    designSystemIds: z.array(z.string()),
});
export const DesignSystem = z.object({
    id: z.string(),
    workspaceId: z.string(),
    name: z.string(),
    description: z.string(),
    docExporterId: nullishToOptional(z.string()),
    docSlug: z.string(),
    docUserSlug: nullishToOptional(DocUserSlugSchema),
    docSlugDeprecated: z.string(),
    isMultibrand: z.boolean(),
    docViewUrl: nullishToOptional(z.string()),
    basePrefixes: z.array(z.string()),
    designSystemSwitcher: nullishToOptional(DesignSystemSwitcher),
    isApprovalFeatureEnabled: z.boolean(),
    approvalRequiredForPublishing: z.boolean(),
    accessMode: DesignSystemAccessMode,
    membersGenerated: z.boolean(),
    sharedDraftId: z.string().optional(),
    iconFileId: z.string().optional(),
    iconFilePath: z.string().optional(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
